if (document.body.classList.contains('collection')) {
  // BEDS SIZE LIST
  function addQuickSizeFilterEventlisteners(){
    document.querySelectorAll(".size_list .checkbox").forEach(checkbox => {
      checkbox.addEventListener("click", (e) => {
        const bedSizeValue = e.target.parentNode.getAttribute('value');
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);

        let foundMatch = false;
        searchParams.forEach((value) => {
          if (value === bedSizeValue) {
            foundMatch = true;
          }
        });

        if (!foundMatch) {
          appendParams(bedSizeValue);
        }
      });
    });
  }
  addQuickSizeFilterEventlisteners();

  const parent = document.querySelector('.size_list');
  function detectStickyMenuOverflow() {
    const child = parent.querySelector('.sizes');
    if (child.scrollWidth > parent.clientWidth)  parent.closest('.container__header').classList.add('element-is-overflown');
    else parent.closest('.container__header').classList.remove('element-is-overflown');
  }
  if (parent) {
    
    detectStickyMenuOverflow();
    window.onresize = detectStickyMenuOverflow;
  }


  // Function to append new parameter to URL
  function appendParams(size) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    // Append the new parameter
    if(size == undefined) return;
    searchParams.delete("filter.p.m.custom.bed_size");
    searchParams.set("filter.p.m.custom.bed_size", size);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, '', url.href);
    updatePageContents(url.href);
  }

  // Function to fetch and update page contents
  function updatePageContents(targetUrl) {
    fetch(targetUrl)
    .then((response) => {
      // When the page is loaded, convert it to text
      return response.text();
    })
    .then((html) => {
      // Initialize the DOM parser
      const parser = new DOMParser();

      // Parse the text
      const fetchedPage = parser.parseFromString(html, "text/html");

      // Replace the current shop-component with the fetched one
      const currentShopComponent = document.querySelector('shop-component');
      const newShopComponent = fetchedPage.querySelector('shop-component');
      if (currentShopComponent && newShopComponent) {
        currentShopComponent.replaceWith(newShopComponent);
        addQuickSizeFilterEventlisteners();
        initializeStickyHeader();
      }
    }) 
    .catch((err) => {  
      console.log('Failed to fetch page: ', err);  
    });
  }

  // Function to initialize sticky header
  function initializeStickyHeader() {
    // elements for the sticky header
    const stickySection = document.querySelector('section > shop-component.sticky-filter');
    const stickyHeader = stickySection.querySelector('.container__header.shop__header');
    const isSticky = document.querySelector('[is-sticky]');

    // Function to adjust the sticky header based on window scroll and size
    function adjustStickyHeader() {
      const sectionBottom = stickySection.offsetTop + stickySection.offsetHeight;
      const windowWidth = window.innerWidth;
      const announcmentBarHeight = document.querySelector('.announcement-bar__inner-container').offsetHeight;

      stickyHeader.style.top = isSticky ? document.querySelector('#header-component').offsetHeight + "px" : '0';

      let paddingValue;
      let checkValue;
      if (windowWidth < 922) {
        paddingValue = "103px";
        checkValue = window.scrollY + 12;
      } else {
        paddingValue = "72px"
        checkValue = window.scrollY + announcmentBarHeight;
      }


      // Checking if the window scroll position is within the section bounds
      if (checkValue >= stickySection.offsetTop ) {
        stickyHeader.style.position = 'fixed'; 
        stickyHeader.style.zIndex = '100'; 
        stickyHeader.style.width = '100%';
        document.querySelector('#ShopActiveFilters').style.paddingTop = paddingValue;
      } else {
        stickyHeader.style.position = ''; 
        stickyHeader.style.zIndex = ''; 
        stickyHeader.style.width = '';
        document.querySelector('#ShopActiveFilters').style.paddingTop = "0px";
      }
    }

    // scroll event listener to adjust sticky header
    window.addEventListener('scroll', adjustStickyHeader);

    const observer = new MutationObserver(adjustStickyHeader);
    observer.observe(stickySection, { attributes: true, childList: true, subtree: true });
  }

  // Initialize sticky header
  initializeStickyHeader();
}
